document.addEventListener('DOMContentLoaded', function () {
    function setupClickEvent() {
        var ss_btn_3 = document.querySelector(".ss_btn");

        if (ss_btn_3) {
            ss_btn_3.addEventListener('click', function () {
                this.classList.toggle("active");
            });
        }
    }

    setupClickEvent();
});
document.addEventListener('DOMContentLoaded', function () {
    var copy = document.querySelector(".copytext");

    if (copy) {
        copy.addEventListener('click', function () {
            var currentUrl = window.location.href;
            console.log(currentUrl, 'reach here');
            var copytext = document.querySelector(".cliptext");
            copytext.innerHTML = 'Link Copied !';
            navigator.clipboard.writeText(currentUrl);
            setTimeout(function () {
                copytext.innerHTML = 'Copy Link';
            }, 2000);
        });
    }
});
function sendLink() {
    var linkElement = document.querySelector(".facebook");
    var currentUrl = window.location.href
   console.log(currentUrl,'this url')
    linkElement.href = `whatsapp://send?text=${currentUrl}`;
    console.log(linkElement.href,'this is hrf');
    
}




